/**
 * @fileoverview Sanderson Farms Navbar
 * @author david@blackairplane.com (David Leggett)
 */

class Navbar {
    constructor(el, config) {
        this.el = el;
        this.searchInput = el.querySelector('.sf-utility-nav__search-input')
        this.searchControl = el.querySelector('.sf-utility-nav__search-control')
        this.primaryNavMenu = el.querySelector('.sf-primary-nav__menu')
        this.utilityNavMenu = el.querySelector('.sf-utility-nav__menu')
        this.navOpen = false
        this.navHamburger = el.querySelector('.sf-navbar__hamburger-button')
        this.closeButton = el.querySelector('.sf-navbar__close-button')
        this.mainBody = document.querySelector('div.main');

        this.init();
    }

    init () {
        this.navHamburger.addEventListener('click', () => {
            this.openNav();
        });

        this.closeButton.addEventListener('click', () => {
            this.closeNav();
        });

        this.searchControl.addEventListener('click', () => {
            this.showMobileSearch();
        });

        // Initial adjust height of navbar offset
        this.adjustPadding();
        // Listen for the window to change size and adjust the offset
        window.addEventListener("resize", () => this.adjustPadding());
        // Listen for the custom navbar event to adjust the offset
        this.el.addEventListener("resized", () => this.adjustPadding());
    }

    adjustPadding() {
        this.mainBody.style.paddingTop = this.el.offsetHeight + "px";
    }

    openNav () {
        this.navOpen = true;

        this.showCloseButton();

        this.primaryNavMenu.classList.add('sf-primary-nav__menu--open');
        this.utilityNavMenu.classList.add('sf-utility-nav__menu--open');
    }

    closeNav (hideCloseButton = true) {
        this.navOpen = false
        this.primaryNavMenu.classList.remove('sf-primary-nav__menu--open');
        this.utilityNavMenu.classList.remove('sf-utility-nav__menu--open');
        this.el.classList.remove('sf-navbar--show-mobile-search');

        if(hideCloseButton) {
            this.navHamburger.classList.remove('sf-navbar__hamburger-button--hide');
            this.closeButton.classList.remove('sf-navbar__close-button--show');
        }
    }

    showCloseButton() {
        this.navHamburger.classList.add('sf-navbar__hamburger-button--hide');
        this.closeButton.classList.add('sf-navbar__close-button--show');
    }

    showMobileSearch() {
        this.closeNav(false);
        this.showCloseButton();
        this.el.classList.add('sf-navbar--show-mobile-search');
        this.searchInput.focus();
    }
}

export default Navbar;
